var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"margin":"0","padding":"0","text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"purple","size":"50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }